export const PrizeType = {
    CASH: 'CASH',
    PHYSICAL_GOODS: 'PG'
};
